import { render, staticRenderFns } from "./monthly-attendances.vue?vue&type=template&id=98e4e0ac"
import script from "./monthly-attendances.vue?vue&type=script&lang=js"
export * from "./monthly-attendances.vue?vue&type=script&lang=js"
import style0 from "./monthly-attendances.vue?vue&type=style&index=0&id=98e4e0ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports